import React, { useEffect, useMemo, useState } from "react";
import Seo from "../common/Components/Seo/Seo";
import SuccessSchema from "../common/Components/StructuredData/SuccessSchema";
import BookingConfirm from "../containers/BookingConfirm/BookingConfirm";
import { nextPage } from "../common/config/nextPage";
import Cookies from "js-cookie";

const Success = () => {
  const [count, setCount] = useState(0);

  //   useEffect(() => {
  //     if (typeof window.sessionStorage !== "undefined") {
  //       const getCount = JSON.parse(sessionStorage.getItem("count"));
  //       sessionStorage.removeItem("detail");
  //       if (getCount > 0) {
  //         nextPage("/");
  //       } else {
  //         setCount(count + 1);
  //       }
  //     }
  //   }, []);

  useMemo(() => {
    if (count > 0) {
      sessionStorage.setItem("count", JSON.stringify(count));
    }
  }, [count]);

  useEffect(() => {
    let value = Cookies.get("customCid");
    if (value) {
      Cookies.remove("customCid");
    }
  }, []);

  return (
    <>
      <Seo
        seo={{
          title: "Booking Confirmed - Thank You | Airport Parking Deals",
          description: "Success! Your airport parking is confirmed. Booking confirmation and parking instructions have been sent to your email. Save up to 60% on airport parking with us.",
          keywords: "booking confirmed, parking confirmed, reservation success, order confirmed, booking complete, confirmation email"
        }}
      />
      <SuccessSchema />
      {/* Primary color background under the absolute header */}
      <div className="w-full bg-[#0C735F] h-28 md:h-[180px]"></div>
      <BookingConfirm />
    </>
  );
};

export default Success;
